import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { ReputationAnalysisPage } from "@/components/site/ReputationAnalysisPage";

import { pageSchemas } from "@/lib/seo/page-schema";
export const Route = createFileRoute("/media-analysis/reputation")({
  head: () => ({
    meta: [
      { title: "Reputation Analysis - Media Intelligence | Perceptica" },
      { name: "description", content: "Perceptica's reputation analysis tracks how stakeholders perceive your brand - themes, sentiment, drivers and recommendations. Get the audit." },
      { property: "og:title", content: "Reputation Analysis - Media Intelligence | Perceptica" },
      { property: "og:description", content: "Perceptica's reputation analysis tracks how stakeholders perceive your brand - themes, sentiment, drivers and recommendations. Get the audit." },

      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Reputation Analysis - Media Intelligence | Perceptica" },
      { name: "twitter:description", content: "Perceptica's reputation analysis tracks how stakeholders perceive your brand - themes, sentiment, drivers and recommendations. Get the audit." },
      { property: "og:url", content: "https://perceptica.com/media-analysis/reputation" },
      ...ogImageMeta("en", "/media-analysis/reputation"),
      { property: "og:type", content: "website" },
    ],
  
    scripts: pageSchemas({ locale: "en", path: "/media-analysis/reputation", service: { name: "Reputation analysis", description: "Perceptica reputation analysis for Southeast Europe.", serviceType: "Reputation analysis" } }),
  }),
  component: ReputationAnalysisPage,
});